import Script from "next/script";
import React from "react";
import { useIubendaPreferences } from "~/features/app/scripts/iubenda/hooks";
import { requestConsentReload } from "~/features/app/scripts/iubenda/controller";
const MARKER_IO_PROJECT_ID = process.env.NEXT_PUBLIC_MARKER_IO_PROJECT_ID;
export function MarkerIoScript() {
  const {
    functionality
  } = useIubendaPreferences();
  const previouslyAllowed = React.useRef(false);
  React.useEffect(() => {
    if (!MARKER_IO_PROJECT_ID) return;
    if (previouslyAllowed.current && !functionality) {
      const marker = (window as Window & {
        Marker?: {
          unload?: () => void;
        };
      }).Marker;
      try {
        marker?.unload?.();
      } catch {
        // A failed vendor teardown must not keep its old permission active.
      }
      requestConsentReload();
    }
    previouslyAllowed.current = functionality;
  }, [functionality]);
  if (!MARKER_IO_PROJECT_ID || !functionality) {
    return null;
  }
  return <>
      <Script id="marker-io-config" dangerouslySetInnerHTML={{
      __html: `window.markerConfig = { project: '${MARKER_IO_PROJECT_ID}', source: 'snippet'};`
    }} strategy="afterInteractive" />
      <Script id="marker-io" dangerouslySetInnerHTML={{
      __html: `!function(e,r,a){if(!e.__Marker){e.__Marker={};var t=[],n={__cs:t};["show","hide","isVisible","capture","cancelCapture","unload","reload","isExtensionInstalled","setReporter","setCustomData","on","off"].forEach(function(e){n[e]=function(){var r=Array.prototype.slice.call(arguments);r.unshift(e),t.push(r)}}),e.Marker=n;var s=r.createElement("script");s.async=1,s.src="https://edge.marker.io/latest/shim.js";var i=r.getElementsByTagName("script")[0];i.parentNode.insertBefore(s,i)}}(window,document);`
    }} strategy="afterInteractive" />
    </>;
}